import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Login from '../pages/general/Login';
import ResetPassword from '../pages/general/ResetPassword';
import ResetConfirmPassword from '../pages/general/ResetConfirmPassword';
import UnlockUserAccount from '../pages/general/UnlockUserAccount';
import ResetUserAccount from '../pages/general/ResetUserAccount';
import { pathLanguageCode } from '../../conf/constants/constants';

const LoadingMessage = <p> Loading... </p>;

function UnauthenticatedApp() {
  return (
    <Router>
      <Suspense fallback={LoadingMessage}>
        <Switch>
          <Route path={`/remuneraciones/${pathLanguageCode}/consultor/login`} component={Login} />
          <Route path={`/remuneraciones/${pathLanguageCode}/fiscalizador/login`} component={Login} />
          <Route path={`/remuneraciones/${pathLanguageCode}/login`} component={Login} />
          <Route path={`/remuneraciones/${pathLanguageCode}/consultor/seguridad/account/reset_password`} component={ResetPassword} />
          <Route path={`/remuneraciones/${pathLanguageCode}/fiscalizador/seguridad/account/reset_password`} component={ResetPassword} />
          <Route path={`/remuneraciones/${pathLanguageCode}/seguridad/account/reset_password`} component={ResetPassword} />
          <Route path={`/remuneraciones/${pathLanguageCode}/seguridad/account/send_unlock_email`} component={UnlockUserAccount} />
          <Route path={`/remuneraciones/${pathLanguageCode}/seguridad/account/reset_password_confirm/:uidb64/:token`} component={ResetConfirmPassword} />
          <Route path={`/remuneraciones/${pathLanguageCode}/seguridad/account/unlock/:uidb64/:token`} component={ResetUserAccount} />
        </Switch>
      </Suspense>
    </Router>
  );
}

export default UnauthenticatedApp;
